import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ButtonAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { ArrowLeftIcon } from '@yonderland/andes-icons';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getHomepageUrl } from '@as-react/common-utils';
export const ContinueShoppingCTA = () => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const { rootWithLanguageSuffix } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    return (_jsx(ButtonAlpha, { fullWidth: isMobile, theme: "branded", variant: "secondary", testId: "continue_shopping", text: t('account.payback.continue.shopping'), onClick: () => {
            window.location.href = getHomepageUrl(rootWithLanguageSuffix);
        }, iconLeft: { source: ArrowLeftIcon, size: 'sm' } }));
};
